// eslint-disable-next-line no-unused-vars
import { Fragment, h, createRef } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import PropTypes from 'prop-types';
import FacetExpandCollapse from './FacetExpandCollapse';
import Item from './Item';

const { __, sprintf } = wp.i18n;

/**
 * Toggle list component.
 * Used to show medium sized list options.
 *
 * @param {object} props Props
 * @param {string} props.type The input type.
 * @param {Array} props.items The array of item objects.
 * @param {string} props.name The input name.
 * @param {string} props.label The facet label.
 * @returns {object} JSX
 */
const ListToggle = ( { type, items, name, label } ) => {

	const checkedItems = items.filter( item => item.selected );
	const uncheckedItems = items.filter( item => !item.selected );
	const [isButtonVisible, setIsButtonVisible] = useState( true );

	useEffect( () => {
		setIsButtonVisible( ( 10 >= uncheckedItems.length ) );
	}, [uncheckedItems] );

	/**
	 * Content component.
	 *
	 * @returns {object} JSX
	 */
	const Content = () => {
		return (
			<>
				{checkedItems.map( ( item ) => {
					return <Item item={item} key={item.id} group={name} type={type} />;
				} )}
				{uncheckedItems.map( ( item, index ) => {
					if ( 10 < index + 1 ) {
						return null;
					}

					return <Item item={item} key={item.id} group={name} type={type} />;
				} )
				}
			</>
		);
	};

	/**
	 * Expanded content component.
	 *
	 * @returns {object} JSX
	 */
	const ExpandedContent = () => {
		return uncheckedItems.map( ( item, index ) => {
			if ( 10 >= index + 1 ) {
				return null;
			}

			return <Item item={item} key={item.id} group={name} type={type} />;
		} );
	};

	return (
		<div className="facet facet--toggle">
			<FacetExpandCollapse
				mainContent={<Content />}
				expandedContent={<ExpandedContent />}
				buttonLabel={sprintf(
					/* translators: %s: the number of items, %s: the label of the facet */
					__( '+ View all %s %s', 'ms-research' ),
					items.length,
					label.toLowerCase()
				)}
				group={name}
				showButton={isButtonVisible}
			/>
		</div>
	);
};

ListToggle.propTypes = {
	type: PropTypes.string.isRequired,
	items: PropTypes.array.isRequired,
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
};

export default ListToggle;
